import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import countries from '../components/countries';
import { Helmet } from 'react-helmet'

import { Link } from 'react-router-dom';

export default function Signup() {

  let [userinfo, setUserinfo] = useState({
    name: "",
    email: "",
    phone: "",
    country: "",
    password: "",
    repassword: ""
  });

  let [err, setErr] = useState("");
  let [check, setCheck] = useState(false);
  let [password1, setPassword1] = useState(false);
  let [password2, setPassword2] = useState(false);
  let [state, setState] = useState(false);
  let [verify, setVerify] = useState(false);
  let [code, setCode] = useState("");
  let [verifyErr, setVerifyErr] = useState("");
  let [rot, setRot] = useState(false);


  const [otp, setOtp] = useState(Array(6).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  let handleEmail = async (e) => {
    e.preventDefault();
    setVerify(false);

    if (userinfo.name === "" || userinfo.phone === "" || userinfo.email === "" || userinfo.password === "" || userinfo.repassword === "" || userinfo.country === "") {
      setErr("All fields are required");

      setTimeout(() => {
        setErr("");
      }, 2000);
    }
    else if (!check) {
      setErr("please accept our terms and conditions");
      setTimeout(() => {
        setErr("");
      }, 2000);
    }
    else if (!userinfo.email.includes('@gmail.com')) {
      setErr("Enter valid gmail address");
      setTimeout(() => {
        setErr("");
      }, 2000);
    }
    else if (userinfo.password.length <= 6) {
      setErr("Password must be greater than 6 digits");
      setTimeout(() => {
        setErr("");
      }, 2000);
    }
    else if (userinfo.password !== userinfo.repassword) {
      setErr("Passwords does not match");
      setTimeout(() => {
        setErr("");
      }, 2000);
    }
    else {
      setState(true);
      let response = await fetch('https://toolisobackend.vercel.app/send-code',
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ email: userinfo.email })
        })
      if (response.status === 200) {
        const data = await response.json();
        setState(false);
        setVerify(true);
        setCode(data.code);
      }
      else {
        setErr("Email failed to send");
        setTimeout(() => {
          setErr("");
        }, 2000);
        setState(false);
      }

    }

  }


  let handleVerify = async (e) => {
    setRot(true);
    e.preventDefault();
    const fullotp = Number(otp.join(""));

    if (fullotp === code) {

      let response = await fetch('https://toolisobackend.vercel.app/addUser', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          name: userinfo.name,
          email: userinfo.email,
          phone: userinfo.phone,
          country: userinfo.country,
          password: userinfo.password
        })
      })
      let data = await response.json();
      if (response.status === 202) {
        setVerifyErr(data.message);
        setTimeout(() => {
          setVerifyErr("");
        }, 3000);
        setRot(false);
      }
      if (response.status === 201) {
        setVerifyErr("Congratulations! Signup successfully");
        setTimeout(() => {
          setVerifyErr("");
        }, 2000);
        if (data.token) {
          localStorage.setItem('token', data.token); // stays for 7 days
        }

        setRot(false);
      }
      if (response.status === 500) {
        setVerifyErr(data.error);
        setTimeout(() => {
          setVerifyErr("");
        }, 3000);
        setRot(false);
      }


    }
    else {
      setVerifyErr("Invalid or Wrong Code");
      setTimeout(() => {
        setVerifyErr("");
      }, 3000);
      setRot(false);

    }

  }

  return (
    <div className='signup'>
      <Helmet>
        <html lang="en" />
        <title>Tooliso Signup – Create Your Free Account Today</title>
        <meta
          name="description"
          content="Join Tooliso to access powerful online tools, save your progress, and unlock premium features. Signing up is free, fast, and secure."
        />
        <meta property="og:title" content="Tooliso Signup – Get Started with Premium Tools" />
        <meta
          property="og:description"
          content="Create your Tooliso account and explore free and paid tools tailored for productivity. Get instant access with a simple signup."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.tooliso.com/signup" />
        <meta property="og:image" content="https://www.tooliso.com/signup-og.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Tooliso Signup – Unlock Your Digital Toolbox" />
        <meta
          name="twitter:description"
          content="Sign up for Tooliso to use advanced online utilities, save your tools, and access exclusive features built for efficiency."
        />
        <meta name="twitter:image" content="https://www.tooliso.com/twitter-signup.jpg" />
      </Helmet>
      <div className="innersignup">
        <form className="secondsignup">
          <h1>Sign Up</h1>
          <input onChange={(e) => setUserinfo({ ...userinfo, name: e.target.value })} value={userinfo.name} placeholder='Enter your Full Name' className='inputsignup' type="text" />
          <input onChange={(e) => setUserinfo({ ...userinfo, phone: e.target.value })} value={userinfo.phone} placeholder='Phone Number' className='inputsignup' type="text" />
          <input onChange={(e) => setUserinfo({ ...userinfo, email: e.target.value })} value={userinfo.email} placeholder='Email address (must be a gmail account)' className='inputsignup' type="text" />
          <div className="fourthsignup">
            <select
              value={userinfo.country}
              onChange={(e) => setUserinfo({ ...userinfo, country: e.target.value })}
            >
              <option value="" disabled>Select a country</option>
              {countries.map((v, i) => (
                <option key={i} value={v}>{v}</option>
              ))}
            </select>
          </div>
          <div className="thirdsignup">
            <input onChange={(e) => setUserinfo({ ...userinfo, password: e.target.value })} value={userinfo.password} placeholder='Enter Password' className='inputsignup' type={`${password1 ? 'text' : 'password'}`} />
            {
              password1 ? <p onClick={() => setPassword1(false)} className='eyecheck'>🔒</p> : <p className='eyecheck'
                onClick={() => setPassword1(true)}>👁️</p>
            }
          </div>
          <div className="thirdsignup">
            <input onChange={(e) => setUserinfo({ ...userinfo, repassword: e.target.value })} value={userinfo.repassword} placeholder='Enter Password again' className='inputsignup' type={`${password2 ? 'text' : 'password'}`} />
            {
              password2 ? <p onClick={() => setPassword2(false)} className='eyecheck'>🔒</p> : <p className='eyecheck' onClick={() => setPassword2(true)}>👁️</p>
            }
          </div>
          <label>
            <input type="checkbox" checked={check} onChange={() => setCheck(!check)} />
            <p>accept terms and conditions and our <Link to={'/privacyPolicy'}>privacy policy</Link></p>
          </label>
          {
            state ?
              <button className='btn1signup'><div className="spinner"></div>
              </button>
              :
              <button className='btn1signup' onClick={handleEmail}><p style={{ color: "black" }}>Verify my Email</p> <FontAwesomeIcon icon={faArrowRight} /></button>
          }
          {
            verify ?

              <div className="fourthsignup">
                <label htmlFor="">Please enter the 6-digit security code we've sent to your email address</label>
                <div className="innerfourthsignup">
                  {[...Array(6)].map((_, i) => (
                    <input
                      key={i}
                      type="text"
                      maxLength={1}
                      value={otp[i]}
                      onChange={(e) => handleChange(e, i)}
                      ref={(el) => (inputRefs.current[i] = el)}
                    />
                  ))}
                </div>
                {
                  rot ?
                    <button className='btn1signup'><div className="spinner"></div></button>
                    :
                    <button className='btn1signup' onClick={handleVerify}><p style={{ color: "black" }}>Confirm</p></button>
                }
                <p style={{ color: 'red' }}>{verifyErr}</p>
                <Link className='linksignup' to={'/'}>Go to Home page</Link>
              </div>
              : ""
          }
          <p style={{ color: "red" }}>{err}</p>
          <div className="linesignup">
            <div></div>
            <p>or</p>
            <div></div>
          </div>
          <p>already have an account? <Link to={'/login'}>Login</Link></p>
        </form>
      </div>
    </div>
  );
}